import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accentColor"];
import { NEUTRAL_400, NEUTRAL_700, OBSIDIAN } from 'visitor-ui-component-library/constants/WidgetColors';
import I18n from 'I18n';
import styled from 'styled-components';
import SVGSendArrow from 'visitor-ui-component-library-icons/icons/SVGSendArrow';
import { getCanReadTextOnce } from 'visitor-ui-component-library/utils/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const Button = styled.button.withConfig({
  displayName: "SendButton__Button",
  componentId: "sc-1w08hvq-0"
})(["border:none;padding:0;width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;margin:auto;background-color:transparent;&:focus-visible{outline-offset:1px;outline:2px solid #00a4bd;}&:hover{& svg{fill:", ";}}&[disabled]{cursor:not-allowed;background-color:transparent;color:", ";& svg{fill:", ";}}"], NEUTRAL_700, NEUTRAL_400, NEUTRAL_400);
const SendIcon = styled(SVGSendArrow).withConfig({
  displayName: "SendButton__SendIcon",
  componentId: "sc-1w08hvq-1"
})(["width:24px;height:24px;margin-right:2px;fill:", ";"], ({
  $accentColor,
  theme
}) => $accentColor !== null && $accentColor !== void 0 ? $accentColor : theme.colors.primary);
export function SendButton(_ref) {
  let {
      accentColor
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isIconReadable = accentColor ? getCanReadTextOnce(accentColor) : true;
  const readableIconColor = isIconReadable ? accentColor : OBSIDIAN;
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.send'),
    "data-test-id": "chat-send-button"
  }, props, {
    children: /*#__PURE__*/_jsx(SendIcon, {
      $accentColor: readableIconColor
    })
  }));
}
SendButton.displayName = 'SendButton';